import { type URLOpenListenerEvent, App } from "@capacitor/app";
import React, { useState, useEffect } from "react";
import LoadingPage from "hub/src/components/common/LoadingPage";
import type { AppLinksInterceptorComponent } from "hub/src/context/AppLinksInterceptor/types";
import { parseAppLinkEvent } from "hub/src/context/AppLinksInterceptor/utils";

export const NativePlatformAppLinksInterceptor: AppLinksInterceptorComponent =
  ({ children }) => {
    // Wait for 350ms to intercept the app link
    const wait = useWait(350);

    const [event, setEvent] = useState<URLOpenListenerEvent | null>(null);

    useEffect(() => {
      const promise = App.addListener(
        "appUrlOpen",
        (event: URLOpenListenerEvent) => {
          setEvent(event);
        },
      );

      return () => {
        promise.then((listener) => listener.remove());
      };
    }, []);

    useEffect(() => {
      if (!event) {
        return;
      }

      const url = parseAppLinkEvent(event);

      if (!url) {
        setEvent(null);
        return;
      }

      window.location.href = url;
      setEvent(null);
    }, [event]);

    if (wait || event) {
      return <LoadingPage />;
    }

    return <>{children}</>;
  };

const useWait = (delay: number) => {
  const [state, setState] = useState(true);

  useEffect(() => {
    setState(true);
    const timer = setTimeout(() => setState(false), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return state;
};
